import { Routes } from '@angular/router';
import { FaqComponent } from 'src/app/static-content/Component/faq/faq.component';
import { TermsComponent } from 'src/app/static-content/Component/terms/terms.component';
import { CartComponent } from 'src/app/cart/cart.component';
import { AboutComponent } from 'src/app/static-content/Component/about/about.component';
import { PrivacyPolicyComponent } from 'src/app/static-content/Component/privacy-policy/privacy-policy.component';
import { hasUploadOrderPermissionGuard } from 'src/app/core/guards/has-upload-order-permission.guard';


export const PRIVATE_ROUTES: Routes = [
    { 
        path: 'home',
        loadChildren: () => import('src/app/home/home.module').then(x => x.HomeModule)
     },
    { path: 'profile', loadChildren: () => import('src/app/profile/profile.module').then(x => x.ProfileModule) },
    { path: 'mycart', loadChildren: () => import('src/app/cart/cart.module').then(x => x.CartModule) },
    { path: 'product', loadChildren: () => import('src/app/product/product.module').then(x => x.ProductModule) },
    { path: 'order', loadChildren: () => import('src/app/order/order.module').then(x => x.OrderModule) },
    { path: 'promotion', loadChildren: () => import('src/app/promotion/promotion.module').then(x => x.PromotionModule) },
    { path: 'feedback',loadChildren: () => import('src/app/feedback/feedback.module').then(x => x.FeedbackModule)
     },
     { 
         path: 'upload-order', 
         loadChildren: () => import('../../upload-order/upload-order.module').then(m => m.UploadOrderModule),
         canActivate:[hasUploadOrderPermissionGuard] 
    },
    { path: 'faq', component: FaqComponent },
    { path: 'terms', component: TermsComponent },
    { path: 'cart', component: CartComponent },
    { path: 'about', component: AboutComponent },
    { path: 'privacy-policy', component: PrivacyPolicyComponent }
];
